module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/interface/arrow-angle-35570524c7410b9f3dc53d945481d4aa.svg";